import axios from "axios";
// config
import { BACKEND_URL } from "../config-global";
import { getApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// ----------------------------------------------------------------------

const httpClient = axios.create({ baseURL: BACKEND_URL });

httpClient.interceptors.request.use(async (config) => {
  // const token = window.localStorage.getItem("accessToken");
  // config.headers.authorization = token;
  const app = getApp();
  const auth = getAuth(app);
  if (!auth.currentUser) return config;
  const token = await auth.currentUser.getIdToken();
  config.headers.authorization = "Bearer " + token;
  return config;
});

httpClient.interceptors.response.use(
  (response) => response,
  (error) =>
    Promise.reject(
      (error.response && error.response.data) || "Something went wrong"
    )
);

export default httpClient;
